import Action from './Action.js'
import Dialogue from './Dialogue.js'
import Character from './Character.js'
import Parenthetical from './Parenthetical.js'
import SceneHeading from './SceneHeading.js'
import Art from './Art.js'
import StoryIcon from './StoryIcon.js'

export default function Scene ({ scene, sceneArt, storyIcon }) {
  return (
    <>
      {sceneArt && <Art url={sceneArt.url} />}
      {scene && scene.map(scene_to_component)}
      {storyIcon && <StoryIcon url={storyIcon} />}
    </>
  )
}

function scene_to_component ({ type, text, texts }, key) {
  switch (type) {
    case 'Action':
      return (<Action key={key}>{text}</Action>)
    case 'Character':
      return (<Character key={key}>{text}</Character>)
    case 'Parenthetical':
      return (<Parenthetical key={key}>{text}</Parenthetical>)
    case 'Dialogue':
      return (<Dialogue key={key}>{texts}</Dialogue>)
    case 'SceneHeading':
      return (<SceneHeading key={key}>{text}</SceneHeading>)
    default:
  }
}
